import { User, Phone, Mail, Calendar, MapPin, Stethoscope } from "lucide-react";
import { PrescriptionOrder } from "../../types/prescription";

interface UserInfoSectionProps {
  prescription: PrescriptionOrder;
}

export function UserInfoSection({ prescription }: UserInfoSectionProps) {
  const userPhones = Array.isArray(prescription.user.phone_numbers)
    ? prescription.user.phone_numbers
    : prescription.user.phone_numbers
    ? [prescription.user.phone_numbers]
    : [];
  const userEmails = Array.isArray(prescription.user.emails)
    ? prescription.user.emails
    : prescription.user.emails
    ? [prescription.user.emails]
    : [];

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <User className="h-4 w-4 text-muted-foreground" />
        <span className="text-sm">{prescription.user.full_name}</span>
      </div>
      {userPhones[0] && (
        <div className="flex items-center gap-2">
          <Phone className="h-4 w-4 text-muted-foreground" />
          <span className="text-sm">{userPhones[0]}</span>
        </div>
      )}
      {userEmails[0] && (
        <div className="flex items-center gap-2">
          <Mail className="h-4 w-4 text-muted-foreground" />
          <span className="text-sm">{userEmails[0]}</span>
        </div>
      )}
      {prescription.session && (
        <div className="flex items-center gap-2">
          <Calendar className="h-4 w-4 text-muted-foreground" />
          <span className="text-sm">Session: {prescription.session.name}</span>
        </div>
      )}
      {prescription.session?.professional?.name && (
        <div className="flex items-center gap-2">
          <Stethoscope className="h-4 w-4 text-muted-foreground" />
          <span className="text-sm">
            Doctor: {prescription.session.professional.name}
          </span>
        </div>
      )}
      {prescription.delivery_address && (
        <div className="flex items-start gap-2 mt-2">
          <MapPin className="h-4 w-4 text-muted-foreground mt-0.5" />
          <div className="flex-1">
            <span className="text-xs text-muted-foreground block mb-1">
              Delivery Address:
            </span>
            <span className="text-sm">{prescription.delivery_address}</span>
          </div>
        </div>
      )}
      {prescription.delivery_phone && (
        <div className="flex items-center gap-2 mt-2">
          <Phone className="h-4 w-4 text-muted-foreground" />
          <div>
            <span className="text-xs text-muted-foreground block mb-1">
              Delivery Phone:
            </span>
            <span className="text-sm">{prescription.delivery_phone}</span>
          </div>
        </div>
      )}
    </div>
  );
}
